export const isDraft = (entity: any) => !entity?.sys?.publishedVersion;
